import React from "react";

export default function Button({
  children,
  type = "button",
  className = "",
  clickHandler,
  ...props
}) {
  return (
    <button
      type={type}
      className={`inline-flex justify-center items-center bg-transparent text-xsm md:text-sm laptop:text-base leading-[24px] font-semibold rounded-full outline-0 -tracking-[0.42] duration-300 cursor-pointer ${className} hover:opacity-85`}
      onClick={clickHandler}
      {...props}
    >
      {children}
    </button>
  );
}
